"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidePinSchema = exports.SlideStudentPinSettingsSchema = exports.SlideTeacherPinSettingsSchema = exports.SlidePinSettingsSchema = exports.SlidePinLayoutTemplateSchema = exports.SlideLayoutPartKeySchema = void 0;
const zod_1 = require("zod");
const pin_component_1 = require("../pin-component");
const layout_part_1 = require("../pin-component/layout-part");
const base_pin_1 = require("./base-pin");
const base_teacher_pin_1 = require("./base-teacher-pin");
const SlidePinLayoutKeySettingsSchema = zod_1.z.enum([
    'BLANK',
    'COVER',
    'IMAGE_ONLY',
    'IMAGE_TOP',
    'IMAGE_LEFT',
    'IMAGE_RIGHT',
    'TITLE_TOP_WITH_BODYTEXT',
    'BODYTEXT_AND_IMAGE_TWO_COLUMNS',
    'BODYTEXT_TWO_COLUMNS',
    'VIDEO_ONLY',
]);
exports.SlideLayoutPartKeySchema = layout_part_1.LayoutPartSchema.extract([
    'TITLE',
    'SUBTITLE1',
    'SUBTITLE2',
    'BODYTEXT1',
    'BODYTEXT2',
    'IMAGE1',
    'IMAGE2',
    'VIDEO',
]);
exports.SlidePinLayoutTemplateSchema = base_pin_1.BaseTemplateLayoutSchema.merge(zod_1.z.object({
    key: SlidePinLayoutKeySettingsSchema,
    layoutParts: zod_1.z.record(exports.SlideLayoutPartKeySchema, pin_component_1.PinComponentSchema.optional()),
}));
exports.SlidePinSettingsSchema = base_pin_1.BasePinSettingsSchema.merge(zod_1.z.object({
    layout: SlidePinLayoutKeySettingsSchema,
    layoutParts: zod_1.z.record(exports.SlideLayoutPartKeySchema, zod_1.z.string().optional()),
}));
exports.SlideTeacherPinSettingsSchema = base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({}));
exports.SlideStudentPinSettingsSchema = zod_1.z.object({});
exports.SlidePinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('SLIDE'),
    settings: exports.SlidePinSettingsSchema,
}));
//# sourceMappingURL=slide-pin.js.map